import { oc } from '@orpc/contract';
import { createRouteInputSchema, routeSchema } from '../schemas/routes.schemas.js';
export const createRouteContract = oc
    .route({
    method: 'POST',
    path: '/routes',
    tags: ['Routes'],
    summary: 'Create a test route at version 1',
    description: 'MANAGER only. Route codes are unique per version.',
})
    .input(createRouteInputSchema)
    .output(routeSchema);
//# sourceMappingURL=create-route.contract.js.map